export default __webpack_public_path__ + "images/location_icon.60f280a.png";